import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface MicAlertPermissionPromptState {
  hasDismissedMicAlertPermissionPrompt: boolean;
  setHasDismissedMicAlertPermissionPrompt: (value: boolean) => void;
}

export const useMicAlertPermissionPromptStore =
  create<MicAlertPermissionPromptState>()(
    persist<MicAlertPermissionPromptState>(
      (set) => ({
        hasDismissedMicAlertPermissionPrompt: false,
        setHasDismissedMicAlertPermissionPrompt: (value) =>
          set({ hasDismissedMicAlertPermissionPrompt: value }),
      }),
      {
        name: "mic-alert-permission-prompt",
        storage: createJSONStorage(() => localStorage),
      },
    ),
  );
